import React from 'react';
import {
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Splash from './Splash';
import Features from './Features';
import Pricing from './Pricing';

import Wave from 'react-wavify'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const Landing = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Welcome"
      style={{backgroundColor:"#FAC9B8"}}
    >
      <Splash></Splash>
      <Wave fill='#53131E'
            paused={false}
            options={{
              height: 70,
              amplitude: 50,
              speed: 0.45,
              points: 4
            }}
            style={{height: "300px",backgroundColor:'#FAC9B8'}}
      />
      <Features></Features>
      <Wave fill='#FFFFFF'
            paused={false}
            options={{
              height: 70,
              amplitude: 50,
              speed: 0.45,
              points: 4
            }}
            style={{height: "300px",backgroundColor:'#53131E'}}
      />
      <Pricing></Pricing>
    </Page>
  );
};

export default Landing;
